import React, { useContext, useState, useEffect } from 'react';
import classNames from 'classnames';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import PropTypes from 'prop-types';

import { faSortAlt } from '@fortawesome/pro-solid-svg-icons';
import { Button } from '@comparethemarketau/manor-button';

import { DrawerHorizontal } from '@comparethemarketau/manor-drawer';

import { withSortState, WithSortStateTypes, SortDirType } from './with_sort_state';
import { MenuItem } from './menu_item';
import { withAvailableQuotes } from '../../products/common/with_available_quotes';
import { findGlobalFontSize } from './find_global_font_size';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center'
    },
    button: {
        padding: 0,
        margin: 0,
        fontWeight: theme.fontWeight.bold
    },
    buttonDisabled: {
        background: 'transparent',
        color: theme.colors.grey500,
        '&:hover': {
            background: 'unset'
        }
    },
    sortButtonText: {
        color: theme.colors.primary500,
        fontWeight: theme.fontWeight.bold
    },
    icon: {
        marginRight: theme.spacing[4],
        width: '1.1rem',
        height: '1.4rem',
        fontWeight: theme.fontWeight.bold
    },
    drawerContainer: {
        '& .StyledDrawerActive': {
            borderRadius: `${theme.spacing[4]} ${theme.spacing[4]} 0 0`
        },
        '& div[direction=bottom]': {
            paddingTop: '0.6rem'
        }
    },
    contentContainer: {
        margin: {
            left: theme.spacing[16]
        }
    }

}));

const _SortDrawer = (props) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    const { sortResultsByPrice, paymentFrequencySelected, sortDir, availableQuotesSize } = props;

    const [visible, setVisible] = useState(false);
    const [htmlFontSize, setHtmlFontSize] = useState(10);

    useEffect(() => {
        setHtmlFontSize(findGlobalFontSize());
    }, []);

    const handleClick = (e) => {
        setVisible(true);
    };

    const handleClose = () => {
        setVisible(false);
    };

    const handleChange = (value) => {
        sortResultsByPrice(paymentFrequencySelected, value);
        setVisible(false);
    };

    return (
        <div className={classNames('test-policyFilters-sort', classes.container)}>
            <Button
                variant="tertiary"
                icon={faSortAlt}
                handleClick={handleClick}
                trackingLabel={'Sorting the results drawer'}
                className={classNames(classes.button, availableQuotesSize === 0 && classes.buttonDisabled) }
                disabled={availableQuotesSize === 0}
            >
                Sort
            </Button>
            <div className={classes.drawerContainer}>
                <DrawerHorizontal
                    trackingLabel="excess filter drawer"
                    visible={visible}
                    handleOverlayClick={handleClose}
                    handleClose={handleClose}
                    size={13.2 * htmlFontSize}
                    overlay
                    overlayOpacity={0.5}
                >
                    <div className={classes.contentContainer} role="listbox" tabIndex="-1">
                        <MenuItem selected={sortDir === SortDirType.ASC} value={SortDirType.ASC} onChange={handleChange}>{'Price (Low-High)'}</MenuItem>
                        <MenuItem selected={sortDir === SortDirType.DESC} value={SortDirType.DESC} onChange={handleChange}>{'Price (High-Low)'}</MenuItem>
                    </div>
                </DrawerHorizontal>
            </div>
        </div>
    );
};

_SortDrawer.propTypes = {
    ...WithSortStateTypes,
    availableQuotesSize: PropTypes.number
};

const SortDrawer = withAvailableQuotes(withSortState(_SortDrawer));
export { SortDrawer };
